export default "__VITE_ASSET__Cr3fq9jJ__"